import template from './component.tpl.html';
import './controller';

/**
 * @ngdoc component
 * @name theme.festzelt-os.component:header
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example <layout-header></layout-header>
 *
 */
angular
    .module('festzelt-os.theme.festzelt-os')
    .component('layoutHeader', {
        templateUrl: template,
        controllerAs: 'vm',
        controller: 'LayoutHeaderCtrl'
    });



// WEBPACK FOOTER //
// ./src/app/theme/festzelt-os/components/header/component.js